import sliceCreator from '../../index.js';
import {PRODUCTION_TRACKING} from '../../../constants/index.js';
const _getProductionTrackingAction = sliceCreator('PRODUCTION_TRACKING', PRODUCTION_TRACKING, 'get');

const { asyncAction: getProductionTrackingAction, reducer, clearData: clearGetProductionTrackingAction } = _getProductionTrackingAction;

export default reducer;

export {
    getProductionTrackingAction,
    clearGetProductionTrackingAction
}